<template>
  <div>
    <vxe-modal
        v-model="isShow"
        width="600"
        height="400"
        resize
        remember
        title="各年度期初余额"
    >
      <div class="add-box clearfix">
        <table-header @add="insertEvent" @remove="removeEvent" @copy="copyEvent"></table-header>
        <vxe-table
            border
            show-overflow
            keep-source
            class="table-style"
            ref="xTable"
            highlight-hover-row
            max-height="270"
            :data="tableData"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'cell' }"
            @scroll="$refs.xTable.clearValidate()"
        >
          <vxe-table-column align="center" type="checkbox" width="40"></vxe-table-column>
          <vxe-table-column
              type="seq"
              width="60"
              align="center"
              title="序号"
          ></vxe-table-column>
          <vxe-table-column field="year" title="纳税年度">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.year" placeholder="必填" type="year" align="center" maxlength="16"
                         @input='$refs.xTable.clearValidate("year")'></vxe-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="initBalance" title="年度期初余额">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.initBalance" placeholder="必填" type="number" maxlength="16"
                         @input='$refs.xTable.clearValidate("initBalance")'></vxe-input>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div class="footer-wrap">
          <Button type="primary" @click="submitEvent('new')">提 交</Button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import {
  assign,
  hideLoading,
  isEmpty,
  isNotEmpty,
  showError,
  showFailMsgList,
  showLoading,
  showSuccess, sleep
} from "@/utils/util";
import {apiGet, apiPost} from "@/utils/api";
import TableHeader from "@/components/common/TableHeader";

export default {
  name: "SetInitBuyerYearInvoice",
  components: {TableHeader},
  data() {
    return {
      isShow: false,
      replaceTaxpayer: null,
      repalceTaxNum: null,
      taxpayerId: null,
      tableData: [],
      dataTmp: {
        replaceTaxpayer: null,
        repalceTaxNum: null,
        taxpayerId: null,
        initBalance: null,
        year: null
      },
      yearList: [],
      editRules: {
        year: [
          {
            validator: this.requireValid,
          },
        ],
        initBalance: [
          {
            validator: this.requireValid,
          },
        ],
      },
    }
  },
  mounted() {
  },
  methods: {
    async requireValid(e) {
      if (isEmpty(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + '必填'))
      }
    },
    async show(row) {
      this.taxpayerId = row.taxpayerId
      this.replaceTaxpayer = row.replaceTaxpayer
      this.repalceTaxNum = row.repalceTaxNum
      let param = {
        taxpayerId: row.taxpayerId,
        replaceTaxpayer: row.replaceTaxpayer,
        type: 1
      }
      showLoading()
      let res = await apiGet("api/order/", "twoReport/getInitBalance", param);
      hideLoading()
      if (res.status != 1) {
        showError("读取数据失败: " + res.message)
        return
      }
      this.isShow = true
      this.tableData = res.data;
      this.$refs.xTable.getTableData().tableData = this.tableData
      this.insertEvent()
    },
    insertEvent() {
      let tableData = this.$refs.xTable.getTableData().tableData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条",
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable.insertAt(checkboxRecords, -1);
    },
    async validEvent() {
      const errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    async submitEvent() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！"
        });
        return
      }
      let param = {
        taxpayerId: this.taxpayerId,
        replaceTaxpayer: this.replaceTaxpayer,
        repalceTaxNum: this.repalceTaxNum
      }
      let initBalanceVoList = []
      this.$refs.xTable.getTableData().tableData.forEach(item => {
        initBalanceVoList.push({
          initBalance: item.initBalance,
          year: item.year.substring(0, 4)
        })
      })
      param.initBalanceVoList = initBalanceVoList
      showLoading()
      let res = await apiPost("api/order/", "twoReport/setBuyerInitBalance", param);
      hideLoading()
      if (res.status == 1) {
        showSuccess("设置成功")
        await sleep(1000)
        this.isShow = false;
        this.$emit("success")
      } else if (res.message) {
        showError(res.message)
      } else if (isNotEmpty(res.data)) {
        showFailMsgList(res.data)
      } else {
        showError("服务端错误")
      }
    },
  }
}
</script>

<style scoped>

</style>